module.exports = __webpack_public_path__ + "img/web2x_zupin.e514ab54.png";